import { render, staticRenderFns } from "./SiteSettingUser.vue?vue&type=template&id=2c806987&scoped=true&"
import script from "./SiteSettingUser.vue?vue&type=script&lang=js&"
export * from "./SiteSettingUser.vue?vue&type=script&lang=js&"
import style0 from "./SiteSettingUser.vue?vue&type=style&index=0&id=2c806987&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c806987",
  null
  
)

export default component.exports